export function createDepositWorker() {
  return new Worker(new URL("./deposit.worker.ts", import.meta.url), {
    name: "stealthos-deposit-prover",
  });
}
